
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Facebook'
})
export default class Facebook extends Vue {}
